/**
 * 信息创建
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './InfoModal.module.scss';
import http from '@/assets/api/http';
import CusotmUpload, { generateFileList } from '@/components/NewUpload';
import { Modal, message, Form, Input, Select, Radio } from 'antd';
import { State } from '../../types';
import { TableActionType as ta } from '@/util/enum';

const FormItem = Form.Item;
const { Option } = Select;

const layout = {
    labelCol: {
        span: 4
    }
};

const InfoModal = (props) => {

    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();

    const _handleOk = () => {
        const { data } = props;
        form.validateFields().then(({ imgUrl, ...fields }) => {
            let url = ta.edit === props.type
                ? '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.updateStrategyClass'
                : '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyMisService.addStrategyClass';

            http(url, { id: data.id, systemType: props.curTabID, imgUrl: imgUrl[0].url, ...fields }, 'POST').then(() => {
                message.success('提交成功');
                setConfirmLoading(false);
                props.closeMode && props.closeMode(true);
            }).catch((e = {}) => {
                message.error(e.message || '提交异常');
                setConfirmLoading(false);
                // props.closeMode && props.closeMode();
            });
        });
    }

    const _handleCancel = () => {
        props.closeMode && props.closeMode();
    }

    //图片
    const onFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    useEffect(() => {
        if (props.type === ta.edit) {
            const { imgUrl, ...fields } = props.data;
            form.setFieldsValue({
                imgUrl: generateFileList(imgUrl),
                ...fields
            });
        }
    }, []);

    return (
        <Modal
            width={520}
            centered
            title={props.title}
            visible={props.visible}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >
            <Form
                {...layout}
                className={styles.container}
                form={form}
            >
                <FormItem
                    name="displayPositionCode"
                    label='显示位置'
                    rules={[{ required: true, message: '请选择' }]}>
                    <Select
                        showSearch
                        placeholder="请选择"
                        filterOption={(input, option) => option.children.indexOf(input) >= 0}
                    >
                        {props.positionList.map(v => <Option key={v.id} value={v.displayPositionCode}>{v.displayPositionName}</Option>)}
                    </Select>
                </FormItem>
                <FormItem
                    name="className"
                    label="分类名称"
                    rules={[{ required: true, message: '请输入分类名称' }]}
                >
                    <Input placeholder="请输入" maxLength={16} />
                </FormItem>
                <FormItem
                    name="imgUrl"
                    label='上传图标'
                    valuePropName='fileList'
                    getValueFromEvent={onFile}
                    rules={[{ required: true, message: '请上传图标' }]}
                    className={styles.imgUrl}
                >
                    <CusotmUpload
                        accept='.png, .jpg, .jpeg, gif'
                        listType="picture-card"
                        wallMode='single'
                        removeError
                        qiniuUploadProps={{ uploadType: 'image' }}
                        beforeUpload={file => {
                            setTimeout(()=>{
                                setConfirmLoading(true);
                            }, 0);

                            const isType = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'video/mp4'];
                            const isGt3M = file.size / 1024 / 1024 > 3;

                            if (!isType.includes(file.type)) {
                                message.warn('只能上传 .png, .jpg, .gif 格式的文件!');
                                file.status = 'error';
                                setConfirmLoading(false);
                                return false;
                            }

                            if (isGt3M) {
                                message.warn('图片必须小于 3M!')
                                file.status = 'error';
                                setConfirmLoading(false);
                                return false;
                            }
                        }}
                        onFileListChange={(file, res) => {
                            res && (res.status === 'success' || res.status === 'error') && setConfirmLoading(false);
                            !res && setConfirmLoading(false);
                        }}
                    >
                        <div style={{ color: '#999', fontSize: '12px' }}>上传图片</div>
                    </CusotmUpload>
                </FormItem>
                <FormItem
                    name="status"
                    label="状态"
                    rules={[{ required: true, message: '请选择状态' }]}
                    initialValue={State.start}
                >
                    <Radio.Group>
                        <Radio value={State.start}>启用</Radio>
                        <Radio value={State.close}>禁用</Radio>
                    </Radio.Group>
                </FormItem>
            </Form>
        </Modal>
    );

}

InfoModal.propTypes = {
    positionList: PropTypes.array,
    data: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object
    ]), // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
    type: PropTypes.string,
    curTabID: PropTypes.string,
};

export default InfoModal;